import { render, staticRenderFns } from "./ActionEdit.vue?vue&type=template&id=84be05a2&"
import script from "./ActionEdit.vue?vue&type=script&lang=js&"
export * from "./ActionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports